/** Public marketing name (production: ChooseRightCareer). */
export const BRAND_NAME = 'ChooseRightCareer';

/** Funnel forms: `public/assets/logo.png`. */
export function getBrandLogoSrc() {
  return `${process.env.PUBLIC_URL || ''}/assets/logo.png`;
}

/** If `logo.png` is missing (404), `img` `onError` can swap to this mark. */
export function getBrandFallbackMarkSrc() {
  return `${process.env.PUBLIC_URL || ''}/crc-favicon.png`;
}
